// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__BdaUe","image":"recipe_image__BtdIE","title":"recipe_title__1jR5P","calories":"recipe_calories__24PXH"};